import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import spacetime, { Spacetime } from "spacetime";
import soft from "timezone-soft";

import { Option } from "./options";
import allTimezones from "./timezone-list";
import moment from "moment";
import { Interval } from "api/interfaces/reportInterface.interface";
import { isEmpty, trim } from "lodash";
import { checkEmpty, isNumber } from "./functions";

let timezoneOptions: TimezoneOption[] = [];

export interface ITimezoneOption {
  value: string;
  label: string;
  abbrev?: string;
  offset?: number;
}

interface TimezoneOption extends Option {
  offset: number;
}

export type ITimezone = ITimezoneOption | string;

// export const transeCalendarPickDay = (
//   date: Date,
//   timezone: string | undefined
// ) => {
//   return spacetime(date, timezone).toNativeDate();
// };

// export const convertDateString = (
//   dateStr: string,
//   info: ProfileAccountInfo,
//   zone?: string
// ) => {
//   let resultDate = "";
//   try {
//     const dd = spacetime(dateStr);
//     resultDate = dd.unixFmt(`${info.dateFormat} ${info.timeFormat}`);
//     if (zone) {
//       const tzStrings = soft(zone);
//       if (tzStrings === undefined || tzStrings.length === 0) {
//         resultDate = resultDate + ` ${zone}`;
//       } else {
//         const zoneTime = spacetime(dateStr, tzStrings[0].iana);
//         resultDate =
//           resultDate + ` ${getTimezoneDisplay(zoneTime, tzStrings[0].iana)}`;
//       }
//     }
//   } catch (error) {}
//   return resultDate;
// };
// export const getTodayTimeZoneDate = (timezone: string | undefined) => {
//   const date =
//     timezone !== undefined ? spacetime.now(timezone) : spacetime.now();
//   return date.toNativeDate();
// };

export const momemntTimeFormat = (dateFormat: string, timeFormat?: string) => {
  return `${dateFormat.toUpperCase()}${
    timeFormat ? ` ${timeFormat.replace(" a", " A")}` : ""
  }`;
};

export const checkOffsetTimezone = (
  timezone: string,
  timezone2: string
): string => {
  let optionTimezone = moment.tz(timezone).utcOffset();
  let localTimezone = moment.tz(timezone2).utcOffset();

  if (optionTimezone === undefined) {
    optionTimezone = spacetime.now(timezone).timezone().current.offset;
  }
  if (localTimezone === undefined) {
    localTimezone = spacetime.now(timezone2).timezone().current.offset;
  }

  if (
    localTimezone !== undefined &&
    optionTimezone !== undefined &&
    localTimezone === optionTimezone
  ) {
    return timezone;
  }
  return "";
};

export const getTimeZoneOptions = () => {
  if (
    timezoneOptions &&
    timezoneOptions.length === Object.keys(allTimezones).length
  ) {
    return timezoneOptions;
  }
  timezoneOptions = makeTimeZoneOptions();
  return timezoneOptions;
};

export const getTodayToUTCDate = (
  timezone: string,
  isEndDay: boolean = false,
  date?: Date | string
) => {
  const now = date || new Date();
  return moment(now)
    .tz(timezone)
    [isEndDay ? "endOf" : "startOf"]("day")
    .utc()
    .toISOString();
};

export const getFirmwareReserveSchedule = (
  reserveTime: string,
  account: ProfileAccountInfo
): string => {
  const timezone =
    account.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [hourPart, minutePart = "0"] = reserveTime.split(":");
  const hour = Number(hourPart);
  const minute = Number(minutePart);

  const nowInTz = moment().tz(timezone);
  const todayReserve = nowInTz
    .clone()
    .startOf("day")
    .hour(hour)
    .minute(minute)
    .second(0)
    .millisecond(0);

  const isScheduledForNextDay = nowInTz.isAfter(todayReserve);
  const scheduledUpdate = isScheduledForNextDay
    ? todayReserve.clone().add(1, "day")
    : todayReserve.clone();

  const scheduledUpdateUtc = scheduledUpdate.utc().toISOString();

  return scheduledUpdateUtc;
};

export const getDisableUpdateTime = (updateDate: string): boolean => {
  const limitMinutes = 30;
  const now = new Date();
  const beforeLimitMinutes = moment(now)
    .subtract(limitMinutes, "minutes")
    .toISOString();
  const afterLimitMinutes = moment(now)
    .add(limitMinutes, "minutes")
    .toISOString();
  return moment(updateDate).isBetween(beforeLimitMinutes, afterLimitMinutes)
    ? true
    : false;
};

// account timezone기준
export const changeTimeByTimezone = (
  date: string,
  timezone: string,
  selectedAccount: ProfileAccountInfo
) => {
  const dateString = `${date.includes(".") ? date.split(".")[0] : date}.000Z`;
  const convertedDate = moment(
    getAccountTimeFormatDate(
      dateString,
      {
        ...selectedAccount,
        timezone: timezone,
        dateFormat: "YYYY-MM-DD",
        timeFormat: "HH:mm:ss",
      },
      false,
      true
    )
  )
    .tz(timezone)
    .utc()
    .format("YYYY-MM-DDTHH:mm:ss.SSSZ");
  return convertedDate;
};
//브라우저 로컬 기준
export const getConvertedUTCDate = (
  date: Date,
  timezone: string,
  selectedAccount?: ProfileAccountInfo
): string => {
  let tz = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const utcDate = moment
    .tz(moment(date).format("YYYY-MM-DD HH:mm:ss"), tz)
    .utc();
  if (selectedAccount) {
    return moment(utcDate).format("YYYY-MM-DD HH:mm:ss");
  }
  return moment(utcDate).toISOString();
};

export const makeTimeZoneOptions = () => {
  return Object.entries(allTimezones)
    .reduce<TimezoneOption[]>((selectOptions, zone) => {
      const now = spacetime.now(zone[0]);
      const tz = now.timezone();

      let label = "";
      let abbr = getTimezoneAbbr(zone[0]);

      const min = tz.current.offset * 60;
      const hr =
        `${(min / 60) ^ 0}:` + (min % 60 === 0 ? "00" : Math.abs(min % 60));
      const prefix = `(GMT${hr.includes("-") ? hr : `+${hr}`}) ${zone[1]}`;

      label = `${prefix} ${abbr && abbr.length < 6 ? `(${abbr})` : ""}`;

      selectOptions.push({
        value: tz.name,
        label: label,
        offset: tz.current.offset,
      });

      return selectOptions;
    }, [])
    .sort((a: TimezoneOption, b: TimezoneOption) => a.offset - b.offset);
};

export const getOffsetInHour = (offsetInMS: number): number => {
  const minInMS = 60 * 60 * 1000;
  return offsetInMS / minInMS;
};

export const getTimezoneOptionsByOffset = (offset: number) => {
  const timezoneOptions = getTimeZoneOptions();
  return timezoneOptions.filter((option) => {
    return option.offset === offset;
  });
};

export const getTimezoneDisplay = (now: Spacetime, timezone: string) => {
  if (timezone === undefined || checkEmpty(timezone)) {
    return "";
  }
  const tzStrings = soft(timezone);

  let abbr = now.timezone().current.isDST
    ? tzStrings[0].daylight?.abbr
    : tzStrings[0].standard?.abbr;

  return abbr;
};

export const getTimezoneAbbr = (timezone: string) => {
  const now = spacetime.now(timezone);
  const tz = now.timezone();
  const tzStrings = soft(timezone);

  let abbr = tz.current.isDST
    ? tzStrings[0].daylight?.abbr
    : tzStrings[0].standard?.abbr;
  if (tzStrings[0].iana === "Pacific/Honolulu") {
    abbr = "HST";
  }
  if (tzStrings[0].iana === "America/Chihuahua") {
    abbr = "CST";
  }
  if (tzStrings[0].iana === "Africa/Cairo") {
    abbr = moment.tz(timezone).zoneAbbr();
  }
  return abbr;
};

export const getAccountTimeDateFormat = (
  time: string,
  info: ProfileAccountInfo
) => {
  let d;
  if (time.includes("+") || time.includes("-")) {
    d = spacetime(time);
  } else {
    d = spacetime(time + "Z");
  }
  try {
    d = d.goto(info.timezone);
  } catch {}

  return d.toNativeDate();
};
// TODO Account정보에 타임존및 Format정보수정 후 인자값 변경.
export const getAccountTimeFormat = (
  time: string,
  info: ProfileAccountInfo,
  displayZone?: boolean
) => {
  return getAccountTimeFormatDate(time, info, displayZone, true);
};

export const checkTimezone = (timezone: string) => {
  try {
    const tzStrings = soft(timezone);
    if (!tzStrings || tzStrings.length === 0) {
      timezone = "";
    } else {
      timezone = tzStrings[0].iana;
    }
  } catch (error) {
    timezone = "";
  }
  return timezone;
};

const getTimezoneIana = (timezone: string) => {
  const tzStrings = soft(timezone);
  if (!tzStrings || tzStrings.length === 0) {
    timezone = "America/Los_Angeles";
  } else {
    timezone = tzStrings[0].iana;
  }
  return timezone;
};

export const convertDateToTimezone = (
  date: string,
  timezone: string,
  exportType: "date" | "moment" = "date"
) => {
  if (!date) return "";
  if (!timezone) return "";
  timezone = getTimezoneIana(timezone);
  if (!timezone) return "";

  if (date.includes("Z")) {
  } else if (date.length >= 19) {
    date = date.substring(0, 19) + "Z";
  } else if (date.length === 10) {
    date = date + "T00:00:00Z";
  } else if (date.length === 8) {
    date =
      date.substring(0, 4) +
      "-" +
      date.substring(4, 6) +
      "-" +
      date.substring(6, 8) +
      "T00:00:00Z";
  } else {
    return "";
  }
  const utcDate = new Date(date);
  if (isNaN(utcDate.getTime())) {
    return "";
  }

  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZoneName: "short",
  });

  const parts = formatter.formatToParts(utcDate);
  const map = Object.fromEntries(parts.map((p) => [p.type, p.value]));
  const convertDate = moment.tz(
    `${map.year}-${map.month}-${map.day} ${map.hour}:${map.minute}:${map.second}`,
    "YYYY-MM-DD HH:mm:ss",
    timezone
  );
  return exportType === "moment" ? convertDate : convertDate.toDate();
};

export const getAccountTimeFormatDate = (
  time: string,
  info: ProfileAccountInfo,
  displayZone?: boolean,
  withTime?: boolean
) => {
  if (!time) return "";
  let timezone =
    info.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (!timezone) return "";
  try {
    const convertDate = convertDateToTimezone(
      time,
      timezone,
      "moment"
    ) as moment.Moment;
    if (!convertDate) return "";

    const formatted = convertDate.format(
      momemntTimeFormat(
        info.dateFormat || "dd/MM/yyyy",
        withTime ? info.timeFormat : undefined
      )
    );

    const zoneAbbr = getTimezoneAbbr(timezone);

    return displayZone ? `${formatted} ${zoneAbbr}` : formatted;
  } catch (error) {
    return "";
  }
};

export const getAccountTimeFormatDateReplace = (
  time: string,
  info: ProfileAccountInfo,
  replaceTimezone: string,
  displayZone?: boolean
) => {
  return getAccountTimeFormatDate(
    time,
    {
      ...info,
      timezone: replaceTimezone,
    },
    displayZone,
    true
  );
};

export const getRecorderTimeFormat = (
  time: string,
  info: ProfileAccountInfo,
  timezone: string,
  displayZone?: boolean,
  isThumbnail?: boolean
) => {
  return getAccountTimeFormatDate(
    time,
    {
      ...info,
      timezone: timezone,
    },
    displayZone,
    true
  );
};

export const getCurrentMilliSecond = () => {
  const now = spacetime.now();
  return now.epoch;
};

/**
 *
 * @param time string
 * @param info redux account info
 * @param interval daily | weekly | monthly
 * @returns
 */
export const getChartTime = (
  time: string,
  info: ProfileAccountInfo,
  interval: Interval
) => {
  if (time === undefined) {
    return "";
  }
  let date = time;
  if (date.includes("Z")) {
    date = time;
  } else if (date.length >= 19) {
    date = date.substring(0, 19) + "Z";
  } else if (date.length === 10) {
    date = date.replaceAll(" ", "-") + "T00:00:00Z";
  } else if (date.length === 8) {
    date = date.replaceAll(" ", "-");
    date =
      date.substring(0, 4) +
      "-" +
      date.substring(4, 6) +
      "-" +
      date.substring(6, 8) +
      "T00:00:00Z";
  } else if (date.length === 7) {
    date = date.replaceAll(" ", "-") + "/01T00:00:00Z";
  } else {
    return "";
  }
  date = date.replaceAll("/", "-");
  date = date.replaceAll(" ", "T");
  const utcDate = new Date(date);
  if (isNaN(utcDate.getTime())) {
    return "";
  }
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: info.timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZoneName: "short",
  });

  const parts = formatter.formatToParts(utcDate);
  const map = Object.fromEntries(parts.map((p) => [p.type, p.value]));
  const convertDate = moment.tz(
    `${map.year}-${map.month}-${map.day} ${map.hour}:${map.minute}:${map.second}`,
    "YYYY-MM-DD HH:mm:ss",
    info.timezone
  );

  let dateFormat = interval === "MONTHLY" ? "MM/YYYY" : "DD/MM/YYYY";
  return convertDate.format(dateFormat);
};

const padTo2Digits = (num: number) => {
  return num.toString().padStart(2, "0");
};

export const convertMsToTime = (milliseconds: number) => {
  let seconds = Math.floor(milliseconds / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);

  seconds = seconds % 60;
  minutes = minutes % 60;

  // 👇️ If you don't want to roll hours over, e.g. 24 to 00
  // 👇️ comment (or remove) the line below
  // commenting next line gets you `24:00:00` instead of `00:00:00`
  // or `36:15:31` instead of `12:15:31`, etc.
  hours = hours % 24;

  return `${padTo2Digits(hours)}:${padTo2Digits(minutes)}:${padTo2Digits(
    seconds
  )}`;
};

export const convertVideoStartMs = (
  startMs: string,
  timezone?: string,
  selectedAccount?: ProfileAccountInfo
) => {
  if (Number(startMs) === 0) return "";
  const date = new Date(Number(startMs)).toISOString();
  return getAccountTimeFormatDate(
    date,
    {
      ...((selectedAccount as ProfileAccountInfo) || {}),
      timezone: timezone || selectedAccount?.timezone || "America/Los_Angeles",
      dateFormat: selectedAccount?.dateFormat || "dd/MM/yyyy",
      timeFormat: selectedAccount?.timeFormat || "hh:mm:ss",
    },
    true,
    true
  );
};

export const convertVideoStartMsVtt = (
  startMs: string,
  timezone?: string,
  selectedAccount?: ProfileAccountInfo
) => {
  const removal = trim(startMs);
  if (timezone === undefined || checkEmpty(timezone)) {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } else {
    const tzStrings = soft(timezone);
    if (tzStrings !== undefined && tzStrings.length !== 0) {
      timezone = tzStrings[0].iana;
    } else {
      if (timezone.includes(",")) {
        const tzStrings2 = soft(timezone.split(`,`)[0]);
        if (tzStrings2 !== undefined && tzStrings2.length !== 0) {
          timezone = tzStrings2[0].iana;
        } else {
          timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        }
      } else {
        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
    }
  }

  const dateFormat = new Date(removal);
  const s = spacetime(dateFormat, timezone);
  return selectedAccount !== undefined
    ? s.unixFmt(`${selectedAccount.dateFormat} ${selectedAccount.timeFormat}`) +
        ` ${getTimezoneDisplay(s, timezone)}`
    : s.unixFmt("yyyy-MM-dd hh:mm a") + ` ${getTimezoneDisplay(s, timezone)}`;
};

export const convertDateToFormat = (
  date: string | moment.Moment,
  format: string
) => {
  return moment(date).format((format ?? "").toUpperCase());
};

export const secondsToDays = (seconds: number) => {
  var days = Math.floor(seconds / 60 / 60 / 24);

  return days;
};

export const secondsToTime = (seconds: number) => {
  var minutes = Math.floor(seconds / 60),
    hours = Math.floor(seconds / 60 / 60),
    days = secondsToDays(seconds);

  // console.log(seconds, minutes, hours, days, "secondsToTime");
  if (days >= 1) return `${days} DAY(S)`;
  if (days < 1 && hours >= 1) return `${hours} HOUR(S)`;
  if (hours < 1 && minutes >= 0) {
    if (minutes === 0) {
      return `1 MINUTE(S)`;
    } else {
      return `${minutes} MINUTE(S)`;
    }
  }
  return undefined;
};

export const convertDateToString = (date: Date) => {
  const d = spacetime(date);
  return d.unixFmt("yyyy-MM-dd");
};

export const changeTimeDaySelect = (date: Date, info: ProfileAccountInfo) => {
  const d = spacetime(date);
  return d.unixFmt(`${info.dateFormat}`);
};

export const convertDateToStringOrigin = (date: Date) => {
  if (date !== undefined) {
    const year = date.getFullYear(); // 2023
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 06
    const day = date.getDate().toString().padStart(2, "0"); // 18
    const dateString = year + "-" + month + "-" + day; // 2023-06-18
    return dateString;
  } else {
    return "";
  }
};

export const generateTimeToFileName = () => {
  const date = new Date();
  const getYear = date.getFullYear();
  const getMonth = (date.getMonth() + 1).toString().padStart(2, "0");
  const getDay = date.getDate().toString().padStart(2, "0");
  const getHour = date.getHours().toString().padStart(2, "0");
  const getMin = date.getMinutes().toString().padStart(2, "0");
  const getSec = date.getSeconds().toString().padStart(2, "0");
  return getYear + getMonth + getDay + "_" + getHour + getMin + getSec;
};

export const generateEpochToFileName = (
  startMs: string | undefined,
  timezone: string
) => {
  if (startMs !== undefined && !checkEmpty(startMs)) {
    if (isNumber(startMs)) {
      // const date = new Date(Number(startMs)/1000);
      // const getYear = date.getFullYear();
      // const getMonth = (date.getMonth() + 1).toString().padStart(2, "0");
      // const getDay = date.getDate().toString().padStart(2, "0");
      // const getHour = date.getHours().toString().padStart(2, "0");
      // const getMin = date.getMinutes().toString().padStart(2, "0");
      // const getSec = date.getSeconds().toString().padStart(2, "0");

      //RND-902 Time format of Download File fix(2-digit)
      if (timezone === undefined || checkEmpty(timezone)) {
        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      } else {
        const tzStrings = soft(timezone);
        if (tzStrings !== undefined && tzStrings.length !== 0) {
          timezone = tzStrings[0].iana;
        } else {
          if (timezone.includes(",")) {
            const tzStrings2 = soft(timezone.split(`,`)[0]);
            if (tzStrings2 !== undefined && tzStrings2.length !== 0) {
              timezone = tzStrings2[0].iana;
            } else {
              timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
          } else {
            timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          }
        }
      }

      const s = spacetime(Number(startMs), timezone);
      return (
        s.unixFmt("MMddyyyy_HHmmss") + `_${getTimezoneDisplay(s, timezone)}`
      );
      //return getYear + getMonth + getDay + "_" + getHour + getMin + getSec;
    } else {
      const removal = trim(startMs);
      if (timezone === undefined || checkEmpty(timezone)) {
        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      } else {
        const tzStrings = soft(timezone);
        timezone = tzStrings[0].iana;
      }

      const dateFormat = new Date(removal);
      const s = spacetime(dateFormat, timezone);
      return (
        s.unixFmt("MMddyyyy_HHmmss") + `_${getTimezoneDisplay(s, timezone)}`
      );
    }
  } else {
    const date = new Date();
    const getYear = date.getFullYear();
    const getMonth = (date.getMonth() + 1).toString().padStart(2, "0");
    const getDay = date.getDate().toString().padStart(2, "0");
    const getHour = date.getHours().toString().padStart(2, "0");
    const getMin = date.getMinutes().toString().padStart(2, "0");
    const getSec = date.getSeconds().toString().padStart(2, "0");
    return getMonth + getDay + getYear + "_" + getHour + getMin + getSec;
  }
};

export const getNextDayString = (days?: number) => {
  let today = new Date();
  if (days) {
    today.setDate(today.getDate() + days);
  } else {
    today.setDate(today.getDate() + 1);
  }
  return convertDateToStringOrigin(today);
};

export const getCookieExpireTime = (hour: number) => {
  var now = new Date();
  var time = now.getTime();
  var expireTime = time + hour * 60 * 60 * 1000;
  now.setTime(expireTime);
  return now;
};

export const excelDateFormat = () => {
  return convertStringDateToMoment().format("MM-DD-YYYY-HH:mm:ss");
};

export const convertVideoShareTime = (date: string, timezone: string) => {
  if (date !== undefined) {
    if (timezone === undefined || checkEmpty(timezone)) {
      timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } else {
      const tzStrings = soft(timezone);
      if (tzStrings !== undefined && tzStrings.length !== 0) {
        timezone = tzStrings[0].iana;
      } else {
        if (timezone.includes(",")) {
          const tzStrings2 = soft(timezone.split(`,`)[0]);
          if (tzStrings2 !== undefined && tzStrings2.length !== 0) {
            timezone = tzStrings2[0].iana;
          } else {
            timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          }
        } else {
          timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        }
      }
    }
    let settingDate = spacetime(date, timezone).goto(timezone);
    // const convertDate = settingDate.d;
    // convertDate.setFullYear(settingDate.year(), settingDate.month(),settingDate.date() );
    // convertDate.setHours(0);
    // convertDate.setMinutes(0);
    // convertDate.setSeconds(0);

    return settingDate.unixFmt("yyyy-MM-dd");
  } else {
    const convertDate = new Date();
    convertDate.setHours(0);
    convertDate.setMinutes(0);
    convertDate.setSeconds(0);
    return convertDateToStringOrigin(convertDate);
  }
};

export const setVideoShareExpire = (date: string, timezone: string) => {
  if (timezone === undefined || checkEmpty(timezone)) {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } else {
    const tzStrings = soft(timezone);
    if (tzStrings !== undefined && tzStrings.length !== 0) {
      timezone = tzStrings[0].iana;
    } else {
      if (timezone.includes(",")) {
        const tzStrings2 = soft(timezone.split(`,`)[0]);
        if (tzStrings2 !== undefined && tzStrings2.length !== 0) {
          timezone = tzStrings2[0].iana;
        } else {
          timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        }
      } else {
        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
    }
  }
  let settingDate = spacetime(date);
  settingDate.goto(timezone);
  settingDate = settingDate.hour(23);
  settingDate = settingDate.minute(59);
  settingDate = settingDate.second(59);
  settingDate = settingDate.millisecond(0);
  // convertDate.setFullYear(settingDate.year(), settingDate.month(),settingDate.date() );
  // convertDate.setHours(23);
  // convertDate.setMinutes(59);
  // convertDate.setSeconds(59);
  // convertDate.setMilliseconds(0);
  return settingDate.iso();
};

export const getMinSecStr = (millisecond: number): string => {
  let sec = Math.floor(millisecond / 1000);
  const min = Math.floor(sec / 60);
  sec = sec - min * 60;
  const minStr = ("00" + min).slice(-2);
  const secStr = ("00" + sec).slice(-2);

  return `${minStr}:${secStr}`;
};

export const oneDayInMs = 1000 * 60 * 60 * 24; // 하루
export const oneHourInMs = 1000 * 60 * 60; // 1시간

/**
 *
 * @param date
 * @returns ms 단위
 * @description 현재시간과 param 시간 차이 구하기
 */

export const substractTimeFromNow = (date: string, now?: Date) => {
  const inputDate = new Date(date);
  const nowDate = now || new Date();

  const diffInMs = nowDate.getTime() - inputDate.getTime();
  return diffInMs;
};

/**
 * @param ms
 * @returns Number
 * @description ms 를 day 날짜로 변경하는 함수
 */
export const convertMsToDays = (ms: number): number => {
  return Math.ceil(ms / oneDayInMs);
};

/**
 *
 * @param date
 * @param withinDays 며칠이내인지
 * @returns boolean
 * @description 현재시간과 원하는 일수 남았는지 확인
 */
export const isWithinDays = (
  date: string,
  withinDays: number,
  lessThan = true
): boolean => {
  const diffInDays = convertMsToDays(substractTimeFromNow(date));

  if (lessThan) {
    return diffInDays <= withinDays && diffInDays >= 0;
  } else {
    return diffInDays >= withinDays && diffInDays >= 0;
  }
};

export function isValidTimeInput(value: string): boolean {
  const regex = /^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d\.\d{3}$/;
  return regex.test(value);
}

export function getTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

const toUtcDateOnlyMs = (d: Date | string) => {
  // 로컬에서 보이는 "연-월-일"을 UTC 자정 기준 timestamp로 고정
  return getUtcDate(d).getTime();
  // const date = typeof d === "string" ? new Date(d) : d;
  // return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
};

/**
 * 두 날짜 사이의 일수 차이를 계산합니다
 * @param dateLeft 첫 번째 날짜
 * @param dateRight 두 번째 날짜
 * @returns 일수 차이 (dateLeft - dateRight)
 */
export function differenceInDays(
  dateLeft: Date | string,
  dateRight: Date | string
): number {
  const left = typeof dateLeft === "string" ? new Date(dateLeft) : dateLeft;
  const right = typeof dateRight === "string" ? new Date(dateRight) : dateRight;

  const diff = toUtcDateOnlyMs(left) - toUtcDateOnlyMs(right);

  // ✅ round 금지: 달력일 차이는 trunc가 안전합니다.
  return Math.trunc(diff / oneDayInMs);
}

/**
 * 날짜에 일수를 더합니다
 * @param date 기준 날짜
 * @param amount 더할 일수
 * @returns 새로운 Date 객체
 */
export function addDays(date: Date, amount: number): Date {
  const baseDate = typeof date === "string" ? new Date(date) : date;
  const base = new Date(
    baseDate.getFullYear(),
    baseDate.getMonth(),
    baseDate.getDate()
  ); // 로컬 00:00 고정
  base.setDate(base.getDate() + amount);
  return base;
}

export function getUtcDate(
  date: Date | string,
  timezone: string = "UTC"
): Date {
  return moment.tz(date, timezone).startOf("day").toDate();
}

export const normalizeToStartOfDay = (d: Date | string) => {
  const next = new Date(d);
  next.setHours(0, 0, 0, 0);
  return next;
};

export const convertStringDateToMoment = (date?: string) => {
  if (!date) return moment();
  return moment.tz(date, "UTC");
};
